import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children?: ReactNode;
  jsxDelete?: ReactNode;
}

type State = {
  hasError: boolean;
  errorText: string;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorText: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorText: error.message };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Caught by ErrorBoundary:", error, errorInfo);

    const alreadyReloaded = sessionStorage.getItem("hasReloadedOnError");

    let isIOSWebView = false;

    try {
      const userAgent = navigator.userAgent;
      const hasReactNativeWebView = !!(window as any).ReactNativeWebView;
      const isiOS = /iPhone|iPad|iPod/i.test(userAgent);
      isIOSWebView = hasReactNativeWebView && isiOS;
    } catch (e) {
      console.error("Error while checking iOS WebView:", e);
    }

    if (!alreadyReloaded && !isIOSWebView) {
      sessionStorage.setItem("hasReloadedOnError", "true");
      window.history.pushState({}, "", window.location.pathname);
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
